import * as React from 'react';
import { Text } from '~ui/components/typography/Text/Text';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultTextAlign = "center";
/**
 * Predefined Text to sync the styles between the validation messages of the different screens.
 */

export var ValidationMessageReason = function ValidationMessageReason(_ref) {
  var children = _ref.children,
      textAlign = _ref.textAlign;
  return /*#__PURE__*/_jsx(Text, {
    textAlign: textAlign !== null && textAlign !== void 0 ? textAlign : defaultTextAlign,
    lineHeight: 1.5,
    children: children
  });
};